import React from "react";
import { connect } from "react-redux";
import { dtmf } from "../actions/dtmfActions";
import Dialer from "../components/Dialer";
import Draggable from "react-draggable";
import "./InCall.css";
import "./DialerView.css";

class DialerViewI extends React.Component {
  constructor(props) {
    super(props);
    this.textInputRef = null;
  }

  componentDidUpdate() {
    // TODO: Ask Nils about this ref
    if (this.textInputRef)
      this.textInputRef.scrollLeft = this.textInputRef.scrollWidth;
  }

  onInputDtmf = event => {
    var textOld = this.props.textDtmf;
    var textNew = this.textInputRef.value;
    var lengthDiff = textNew.length - textOld.length;

    //No change
    if (lengthDiff !== 1) {
      return;
    }

    var msg = textNew.substring(textOld.length, textNew.length);

    this.props.dtmf(msg);
  };

  render() {
    const { isVisible, textDtmf, dtmf } = this.props;
    return (
      <div
        className={
          "dialer-container incall-dialer-container" +
          (isVisible ? "" : " display-none")
        }
      >
        <Draggable>
          <div className={"dialer-view"}>
            <div>
              <input
                value={textDtmf}
                className="form-control inCall-dialer"
                type="text"
                ref={o => (this.textInputRef = o)}
                onInput={this.onInputDtmf}
              />
              <Dialer
                className="margin-top-1em"
                onClick={str => {
                  dtmf(str);
                }}
                inCall={true}
              />
            </div>
          </div>
        </Draggable>
      </div>
    );
  }
}
const mstp = state => {
  return {
    isVisible: state.call.dialerVisible,
    textDtmf: state.call.text_dtmf,
  };
};

const mdtp = dispatch => {
  return {
    dtmf: str => {
      return dispatch(dtmf(str));
    },
  };
};

export default connect(mstp, mdtp)(DialerViewI);






// WEBPACK FOOTER //
// ./src/containers/DialerView.jsx